module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/list/project-list-filter/project-list-filter.component.scss
// module id = ./src/app/projects/list/project-list-filter/project-list-filter.component.scss
// module chunks = main